import { motion } from "framer-motion";
import { FiShield } from "react-icons/fi";
import { useLanguage } from "../contexts/LanguageContext";

const Privacy = () => {
    const { t } = useLanguage();
    return (
        <div className="max-w-4xl mx-auto py-12 space-y-12">
            {/* Header */}
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="text-center space-y-4"
            >
                <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-purple-500 to-blue-500 text-white rounded-2xl mb-4">
                    <FiShield className="w-8 h-8" />
                </div>
                <h1 className="text-4xl font-bold bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent">
                    {t("privacy.title")}
                </h1>
                <p className="text-gray-600 dark:text-gray-400">
                    {t("privacy.lastUpdate")}
                </p>
            </motion.div>

            {/* Content */}
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                className="space-y-8"
            >
                {[1, 2, 3, 4, 5, 6, 7, 8].map((num) => (
                    <section className="space-y-6" key={num}>
                        <h2 className="text-2xl font-bold mb-2">
                            {t(`privacy.section${num}.title`)}
                        </h2>
                        <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                            {t(`privacy.section${num}.content`)}
                        </p>
                    </section>
                ))}
            </motion.div>
        </div>
    );
};

export default Privacy;
